<template>
  <div id="app">
    <router-view />
    <!-- 全局消息通知组件 -->
    <MessageNotification />
  </div>
</template>

<script>
import MessageNotification from "@/components/MessageNotification.vue";

export default {
  name: "App",
  components: {
    MessageNotification,
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/App.vue